import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'

import "./Navbar.css"

const Navbar = () => {
  const { currentUser } = useContext(AuthContext)
  const {switchTheme, isLight} = useContext(ThemeContext)

  const [logo, setLogo] = useState(false)

  const checker = () => {
    const windowSize = window.innerWidth

    if(windowSize < 600){
      setLogo(false)
    } else {
      setLogo(true)
    }
  }

  window.addEventListener('resize', checker)
  
  React.useEffect(checker, [])
  
  return (
    <nav className={`navbar ${isLight ? "" : "dark"}`}>
      <div className="navbar__container">
        <div className="navbar__header">
          <Link to="/">
            <h1 className="navbar__header__heading">
              {logo ? "ThePlatform" : "TP"}
              {/* ThePlatform */}
            </h1>
          </Link>
        </div>
        <ul className="navbar__links">
          {currentUser ? (
          <>
            <li className="navbar__links__link">
              <Link to="/create-post">
                <i className="fas fa-plus" />
              </Link>
            </li>
            <li className="navbar__links__link">
              <Link to="/settings">
                <i className="fas fa-user-cog" />
              </Link>
            </li>
            <button className="navbar__theme" onClick={switchTheme}>
              <i className={isLight ? "fas fa-moon" : "fas fa-sun"}></i>
            </button>
          </>
          ) : (
            <>
              <li className="navbar__links__link">
                <Link className="navbar__signup" to="/signup">
                  Create Account
                </Link>
              </li>
              <li className="navbar__links__link">
                <Link className="navbar__login" to="/login">
                  Login
                </Link>
              </li>
              <button className="navbar__theme" onClick={switchTheme}>
                <i className={isLight ? "fas fa-moon" : "fas fa-sun"}></i>
              </button>
            </>
          )}
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
